import _ from 'lodash'
import storageUtil from '@/helpers/storage'
import decode from 'jwt-decode'

export default {
  methods: {
    getPermissions(){
      return decode(storageUtil.getKey('auth_token')).permissions.split('|');
    },
    havePermission (permission) {
        return this.getPermissions().indexOf(permission) !== -1
    },
    haveModulePermission (module) {
      return _.find(this.getPermissions(), o => {
          let split = o.split('_')
          return split[0] === module
      })
    },
    haveAnyPermission (permissions) {
        return _.intersection(this.getPermissions(), permissions).length > 0
    }
  }
}
